import { result } from 'underscore';
import { BaseSurvey } from '../base-survey';
import { ESCWebUISurveyView } from './view';

export class EscWebuiUserSurvey extends BaseSurvey {
  getSurveyName = () => 'EscWebuiUserSurvey';

  getSurveyId = () => '0530745d-b26b-4b96-8ab5-95369835872c';

  getSurveyProduct = () => 'ESC';

  getSurveyInterface = () => 'Web';

  getInitializationConfig = () => ({
    initGroup: 100,
    initStartDate: '2023-02-03',
    initEndDate: '2023-08-02',
  });

  validateTriggerCondition = () => {
    this.logActivity(`validateTriggerCondition | survey: ${this.getSurveyName()}, Start`);

    // should not be AAD users, AAD users can be included in the future after OCPS integration
    const isNonAADUser = !result(this.serverContext, 'IsAADUser');

    if (!isNonAADUser) {
      this.logActivity(`validateTriggerCondition | survey: ${this.getSurveyName()}, isNonAADUser: ${isNonAADUser}`);
      return false;
    }

    // should be active user more than 30 days
    const userCreatedDateTime = new Date(result(this.serverContext, ['CurrentUser', 'CreatedDateTime']));
    const surveyPreference30DaysAgo = this.SurveyPreferenceService.getDaysAgo(30);
    const isUserActiveOneMonth = userCreatedDateTime <= surveyPreference30DaysAgo;

    if (!this.isTestEnv && !isUserActiveOneMonth) {
      this.logActivity(`validateTriggerCondition | survey: ${this.getSurveyName()}, isTestEnv: ${this.isTestEnv}, isUserActiveOneMonth: ${isUserActiveOneMonth}, userCreatedDateTime: ${userCreatedDateTime}, surveyPreference30DaysAgo: ${surveyPreference30DaysAgo}`);
      return false;
    }

    // conditions copied from Qualtrics
    const isEnglishUser = result(this.serverContext, ['CurrentUser', 'Language']) === 'EN';
    const isNotInternalUser = result(this.serverContext, ['CurrentUser', 'IsInternal']) !== true;
    const isNotSupportUser = !result(this.serverContext, ['CurrentUser', 'Name']).includes('@microsoftsupport.com');
    const isNotE2EMode = !window.navigator.webdriver;
    const isProdUrl = window.location.href.toLocaleLowerCase().includes('https://ui.ads.microsoft.com/');
    const isMcaUrl = window.location.href.toLocaleLowerCase().includes('campaign/mca');
    const isWebUICSATSurveyEnabled = window.location.href.includes('isWebUICSATSurveyEnabled=true');

    const qualtricsConditions =
      (this.isTestEnv &&
        isWebUICSATSurveyEnabled) || // should be test env
      (isEnglishUser && // should be English user
        isNotInternalUser && // not internal users
        isNotSupportUser && // not support team users
        isNotE2EMode && // not test mode
        isProdUrl && // should be Prod URL
        isMcaUrl); // should be MCA URL

    if (!qualtricsConditions) {
      if (!isEnglishUser) {
        this.logActivity(`validateTriggerCondition | survey: ${this.getSurveyName()}, qualtricsConditions: ${qualtricsConditions}, isEnglishUser: ${isEnglishUser}`);
        return false;
      }

      if (!isNotInternalUser) {
        this.logActivity(`validateTriggerCondition | survey: ${this.getSurveyName()}, qualtricsConditions: ${qualtricsConditions}, isNotInternalUser: ${isNotInternalUser}`);
        return false;
      }

      if (!isNotSupportUser) {
        this.logActivity(`validateTriggerCondition | survey: ${this.getSurveyName()}, qualtricsConditions: ${qualtricsConditions}, isNotSupportUser: ${isNotSupportUser}`);
        return false;
      }

      if (!isNotE2EMode) {
        this.logActivity(`validateTriggerCondition | survey: ${this.getSurveyName()}, qualtricsConditions: ${qualtricsConditions}, isNotE2EMode: ${isNotE2EMode}`);
        return false;
      }

      if (!isProdUrl) {
        this.logActivity(`validateTriggerCondition | survey: ${this.getSurveyName()}, qualtricsConditions: ${qualtricsConditions}, isProdUrl: ${isProdUrl}`);
        return false;
      }

      if (!isMcaUrl) {
        this.logActivity(`validateTriggerCondition | survey: ${this.getSurveyName()}, qualtricsConditions: ${qualtricsConditions}, isMcaUrl: ${isMcaUrl}`);
        return false;
      }

      return false;
    }

    this.logActivity(`validateTriggerCondition | survey: ${this.getSurveyName()}, Pass. userCreatedDateTime: ${userCreatedDateTime}, surveyPreference30DaysAgo: ${surveyPreference30DaysAgo}`);

    return true;
  };

  getSurveyComponent = () => ESCWebUISurveyView;

  isReportingPipelineEnabled = () => true;
}
